import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class TagCodeItem extends Component {
  state = {
    chkValue: false,
  };
  componentDidMount = () => {
    const { tagCode, chkCode } = this.props.childProps;
    //console.log(chkCode)
    //console.log(tagCode)

    const pos = chkCode.find((item, index) => {
      return tagCode.toString() === item;
    });

    if (pos !== undefined) {
      this.setState({
        chkValue: true,
      });
    }
  };
  _checkChange = (e) => {
    ////console.log(e)
    const { chkValue } = this.state;
    const { tagCode, tagCodeAdd, tagCodeDel } = this.props.childProps;

    if (!chkValue) {
      tagCodeAdd(tagCode);
      //TagSearchList 함수 Props로 받아서 "202007|202001" 형식으로 만들어 보낼것.
    } else {
      tagCodeDel(tagCode);
      //해당 코드 삭제.
    }

    this.setState({
      chkValue: !chkValue,
    });
  };
  render() {
    const { chkValue } = this.state;
    const { tagCode, tagName, init } = this.props.childProps;
    return (
      <Fragment>
        <dd>
          <div className="chek_group">
            <input
              name="선택"
              id={`checkbox_${tagCode}`}
              type="checkbox"
              value=""
              checked={init ? false : chkValue}
              className="checkbox_img"
              onChange={this._checkChange}
            />
            <label htmlFor={`checkbox_${tagCode}`}>#{tagName}</label>
          </div>
        </dd>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagCodeItem));
